
export const SET_IS_MERCHANTS_LOADING = 'SET_IS_ALL_MERCHANTS_LOADING'
export const SET_IS_OFFERS_LOADING = 'SET_IS_OFFERS_LOADING'
export const SET_IS_NOTIFICATIONS_SETTINGS_LOADING = 'SET_IS_NOTIFICATIONS_SETTINGS_LOADING'
